module.exports = __webpack_public_path__ + "img/709bb06.jpg";